// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 10323); hand-edits allowed (see docs/architecture.md)

/** `this.COREAN_RANDOM` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_COREAN_RANDOM(): any {
  return [
    0,
    { "angle_diap": 15, "angle_mult": 570, "force_diap": 10, "force_mult": 0.1 },
    { "angle_diap": 8, "angle_mult": 570, "force_diap": 5, "force_mult": 0.1 },
    { "angle_diap": 6, "angle_mult": 570, "force_diap": 5, "force_mult": 0.09 },
    { "angle_diap": 0, "angle_mult": 0, "force_diap": 3, "force_mult": 0.06 },
    { "angle_diap": 0, "angle_mult": 0, "force_diap": 1, "force_mult": 0.06 },
    { "angle_diap": 0, "angle_mult": 0, "force_diap": 0, "force_mult": 0 }
  ];
}
